export const CLASS_GRID_ROW_HEIGHT = 70;
export const CLASS_GRID_TEACHER_NAME_HEIGHT = 20;
export const ROW_BUFFER = 10;
export const DEFAULT_GRID_ROW_HEIGHT = 23;




// WEBPACK FOOTER //
// ./app/components/renderers/constants.js